export default __webpack_public_path__ + "static/media/4-4.05ba8426.jpg";